import { format } from 'date-fns';
import { useLayoutEffect } from 'react';
import { InputProps } from 'semantic-ui-react';
import styled from 'styled-components';

import { useIsDesktop } from 'app/theme/useBreakpoints';
import { DateTimePicker } from 'pkg/components/DateTimePicker';
import { DatePicker } from 'pkg/components/DateTimePicker/DatePicker';
import { useDateTimePickerInput } from 'pkg/components/DateTimePickerInput/useDateTimePickerInput';
import { InputWithIcon } from 'pkg/components/InputWithIconAndValidation/InputWithIcon';

import { TimePicker } from '../DateTimePicker/TimePicker';

interface DateTimePickerInputProps extends Omit<InputProps, 'children' | 'value'> {
  date: Date | null;
  setDate: (date: Date) => void;
  inputIcon: JSX.Element;
}

const PickerContainer = styled.div`
  position: relative;
  overflow: visible;
`;

const DateTimePopup = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.popup};
`;

export const DateTimePickerInput = ({ date, setDate, ...inputProps }: DateTimePickerInputProps): JSX.Element => {
  const { popupRef, open, handleMouseDown, handleSetDate, handleReject } = useDateTimePickerInput(setDate);
  const isDesktop = useIsDesktop();

  useLayoutEffect(() => {
    if (open) {
      popupRef.current?.scrollIntoView();
    }
  }, [open, popupRef]);

  return (
    <PickerContainer ref={popupRef}>
      <InputWithIcon
        value={date ? format(date, 'dd-MM-yyyy hh:mm a') : ''}
        onMouseDown={handleMouseDown}
        {...inputProps}
      />
      {open && (
        <DateTimePopup>
          <DateTimePicker
            column={!isDesktop}
            onReject={handleReject}
            setDate={handleSetDate}
            date={date}
            modalRef={popupRef}
          >
            <DatePicker />
            <TimePicker />
          </DateTimePicker>
        </DateTimePopup>
      )}
    </PickerContainer>
  );
};
